module.exports = __webpack_public_path__ + "static/media/purchase-history.23b71583.svg";